import { useEffect } from 'react';
import { addTranslationForLanguage, setActiveLanguage } from 'react-localize-redux';
import { useDispatch, useSelector } from 'react-redux';
import types from '../../../Redux/actions/types';
import { useLocalization } from './LocalizationContext';

const selectLegacyActiveLanguage = (state) => state.localize?.languages?.find((language) => language.active)?.code;

/**
 * Mirrors the locale and dictionaries of LocalizationProvider into react-localize-redux and
 * `tempEdge.lang`, the two stores the unmigrated screens still read.
 * @returns {null} Nothing is rendered.
 * @author armandoricosandoval -ai-
 */
const LegacyLocalizeSync = () => {
  const dispatch = useDispatch();
  const legacyActiveLanguage = useSelector(selectLegacyActiveLanguage);
  const isLegacyReady = Boolean(legacyActiveLanguage);
  const localization = useLocalization();
  const locale = localization?.locale;
  const dictionaries = localization?.dictionaries;

  useEffect(() => {
    if (!isLegacyReady || !dictionaries) {
      return;
    }
    dispatch(addTranslationForLanguage(dictionaries.en, 'en'));
    dispatch(addTranslationForLanguage(dictionaries.es, 'es'));
    dispatch({ type: types.GET_LANGUAGE, payload: { english: dictionaries.en, spanish: dictionaries.es } });
  }, [isLegacyReady, dictionaries, dispatch]);

  useEffect(() => {
    if (isLegacyReady && locale && locale !== legacyActiveLanguage) {
      dispatch(setActiveLanguage(locale));
    }
  }, [isLegacyReady, legacyActiveLanguage, locale, dispatch]);

  return null;
};

export default LegacyLocalizeSync;
